<div class="container">
  <div class="row">
    <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
      <div class="col-12">
        <div class="row">
          <app-greeting></app-greeting>
          <div class="col-12 col-md-4 tptxt-gbdpg">
            <h4>Video Tutorials</h4>
          </div>
          <div class="col-12 col-md-8 right-align">
            <button
              type="button"
              class="btn-actvtytp text-decoration-none justify-content-end gbdpg-righttxt display-inline"
              data-bs-toggle="modal"
              data-bs-target="#feedbackModel"
            >
              Provide Feedback
            </button>
            <a
              class="btn-actvtytp text-decoration-none justify-content-end gbdpg-righttxt display-inline"
              href="https://rmsipl.freshdesk.com/en/support/solutions/articles/36000468140-smartoperator-faqs"
              target="_blank"
              >Go To FAQs
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-12 right-align"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row" *ngFor="let title of quickSelectOptions">
      <div class="shadow-lg p-3 mb-5 bg-body rounded">
        <div class="card dark mt-1">
          <div style="display: flex">
            <div class="col-4">
              <iframe
                class="card-img-top"
                [src]="title.url | safeUrl"
                width="100%"
                height="100%"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
            <div class="col-8">
              <div class="card-body">
                <h5 class="card-title empl-tptxt">{{ title.name }}</h5>
                <p class="card-text">
                  {{ title.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />
</div>
<div class="modal fade" id="feedbackModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <img src="../../../assets/images/svg/notification-icon.svg" />
        <span class="modal-title heading-cnt" id="exampleModalLabel">Feedback</span>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Please let us know your feedback about the tool & how to make it better for you!</p>
        <textarea class="form-control" rows="4" [(ngModel)]="feedback"></textarea>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="saveFeedback()">Submit</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Exit</button>
        </div>
      </div>
    </div>
  </div>
</div>
